// ABOUTME: class-variance-authority variants of CButton — variant, size and colour classes
// ABOUTME: Kept apart from the component so CButton.tsx exports only the component

import { cva } from "class-variance-authority"

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer [&_svg]:pointer-events-none [&_svg]:shrink-0 shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline: "border border-gray-300 bg-white shadow-sm hover:bg-gray-100 hover:text-gray-900",
        secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-gray-100 hover:text-gray-900",
        link: "text-primary underline-offset-4 hover:underline",
        dark: "bg-gray-800 text-white shadow hover:bg-gray-700",
        none: "bg-transparent text-current",
        light: "bg-white text-gray-900 border border-gray-300 shadow-sm hover:bg-gray-50",
      },
      // The design has three control heights and no more: 30 for a service control in a card
      // corner ("Назад", "RU"), 36 on desktop and tablet, 44 for touch
      // (docs/design/Дизайн-система.dc.html §04).
      size: {
        default: "min-h-[30px] px-3 text-sm",
        xs: "min-h-[30px] px-2.5 text-sm",
        sm: "min-h-[30px] px-3 text-sm",
        md: "min-h-9 px-4 py-2",
        /** @deprecated 40px — a Flowbite leftover, off the scale. Use `md` (+ `max-md:min-h-11`). */
        lg: "min-h-10 px-8",
        /** @deprecated 48px — a Flowbite leftover, off the scale. Use `touch`. */
        xl: "min-h-12 px-10 text-base",
        // 44px comfortable touch target — the control height of standalone screens
        // (auth, 404, errors) and of every control on a phone. See docs/DESIGN_SYSTEM.md §1.
        touch: "min-h-11 px-4 text-control",
        icon: "min-h-9 w-9",
      },
      pill: {
        true: "rounded-full",
        false: "rounded-lg",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
      pill: false,
    },
  },
)
